import React, { useState } from 'react';
import AIAnalytics from './components/AIAnalytics';
import VMS from './components/VMS';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('ai-analytics');

  const TABS = {
    'ai-analytics': {
      label: 'AI Analytics',
      title: 'AI Analytics Calculator',
      subtitle: 'Estimate the server hardware required for AI analytics workloads.',
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <rect x="9" y="9" width="6" height="6" />
          <path d="M9 1v3M15 1v3M9 20v3M15 20v3M1 9h3M1 15h3M20 9h3M20 15h3" />
        </svg>
      ),
    },
    vms: {
      label: 'VMS',
      title: 'VMS Calculator',
      subtitle: 'Estimate the server hardware required for camera recording and streaming.',
      icon: (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="2" y="3" width="20" height="8" rx="2" />
          <rect x="2" y="13" width="20" height="8" rx="2" />
          <path d="M6 7h.01M6 17h.01" />
        </svg>
      ),
    },
  };
  const current = TABS[activeTab];

  return (
    <div className="app-shell">
      {/* ── Sidebar ── */}
      <aside className="app-sidebar">
        <div className="sidebar-brand">
          <img src="/logo.png" alt="DeepSight AI Labs" className="sidebar-logo" />
        </div>
        <nav className="sidebar-nav" aria-label="Calculators">
          {Object.entries(TABS).map(([id, tab]) => (
            <button
              key={id}
              type="button"
              className={`sidebar-item ${activeTab === id ? 'active' : ''}`}
              onClick={() => setActiveTab(id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </aside>

      {/* ── Main ── */}
      <div className="app-main">
        <main className="main-content">
          <div className="page-header">
            <h1 className="page-title">{current.title}</h1>
            <p className="page-subtitle">{current.subtitle}</p>
          </div>

          <div className="calculator-card">
            {activeTab === 'ai-analytics' && <AIAnalytics />}
            {activeTab === 'vms' && <VMS />}
          </div>
        </main>

        <footer className="app-footer" id="about-section">
          <div className="footer-content">
            <a
              href="https://deepsightlabs.com/"
              className="footer-website-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              deepsightlabs.com
            </a>
            <div className="footer-social-links" aria-label="DeepSight social links">
              <a
                href="https://www.facebook.com/DeepSightLabs/"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DeepSight AI Labs on Facebook"
              >
                <span className="social-icon facebook-icon">f</span>
              </a>
              <a
                href="https://www.linkedin.com/company/deepsight-ai-labs/"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DeepSight AI Labs on LinkedIn"
              >
                <span className="social-icon linkedin-icon">in</span>
              </a>
            </div>
            <span>&copy; {new Date().getFullYear()} DeepSight AI Labs. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
